export default __webpack_public_path__ + "static/media/dimension-logo-new.d65b7ea8.svg";